import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { computed, observable, autorun } from 'mobx';
import ZtServiceFactory from '@src/services/zt';
// import reload from '@src/utils/reload';
// import { noop } from '@src/utils/common-util';
// import BusinessAccountInfoStore from '@src/business-components/business-account-info';
import { autobind } from 'core-decorators';
import { useMount } from 'ahooks';

class BaseStore {
  /**
   * 历史记录
   */
  @observable $history;

  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  /**
   * 登录状态
   * @returns {*}
   */
  @observable isJinShanLogin = false;

  /**
   * ssg 登录
   * 当前登录账号
   * @returns {undefined|*}
   */
  @computed
  get currentLoginAccount() {
    return window.XPASS?.$accountStore?.name;
  }

  @autobind
  exitAccount() {
    if (window.XPASS) {
      window.XPASS.exit().then(() => {
        window.location.reload();
      });
    }
  }

  @autobind
  login() {
    window.XPASS.signin();
  }

  @autobind
  exit() {
    this.exitAccount();
  }

  /**
   * 跳转至具体的路由
   * @param {string} url - 跳转路由地址
   * @param {boolean} [isReplace] - 是否替换
   */
  redirect(url, isReplace = false) {
    if (isReplace) {
      this.$history.replace(url);
    } else {
      this.$history.push(url);
    }
  }

  use(props) {
    this.$props = props;
    this.$history = useHistory();
    /**
     * 路由参数
     * @type {History<LocationState>}
     */
    this.$routeParams = useParams();
    this.$routeMatch = useRouteMatch();

    useMount(() => {
      autorun(() => {
        this.isJinShanLogin = window.XPASS?.$accountStore?.loginStatus || false;
      });
    });
  }
}

export default BaseStore;
